import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    name: String,
    shortName: String
  }

  connect() {
    this.initCollapseAll()
  }

  initCollapseAll() {
    const collapseBtn = this.element.querySelector(".js-collapse-all")
    if (collapseBtn) {
      collapseBtn.addEventListener('click', () => {
        this.element.querySelectorAll('.collapse').forEach(el => {
          const collapse = window.bootstrap.Collapse.getOrCreateInstance(el)
          collapse.hide()
        })
      })
    }

    const expandBtn = this.element.querySelector(".js-expand-all")
    if (expandBtn) {
      expandBtn.addEventListener('click', () => {
        this.element.querySelectorAll('.collapse').forEach(el => {
          const collapse = window.bootstrap.Collapse.getOrCreateInstance(el)
          collapse.show()
        })
      })
    }

    this.element.querySelectorAll(".js-card-title").forEach(elTitle => {
      const elInput = elTitle.closest(".card").querySelector('input[type="text"]')
      if (elInput) {
        elTitle.textContent = elInput.value
        elInput.addEventListener('input', () => {
          elTitle.textContent = elInput.value
        })
      }
    })
  }

  add(event) {
    const btn = event.currentTarget

    if (!window._.config.ENABLE_JS_LIST) {
      const parent = btn.closest('fieldset') || btn.parentElement
      const hiddenItem = parent.querySelector('fieldset.d-none')
      if (hiddenItem) {
        hiddenItem.classList.remove('d-none')
        hiddenItem.querySelectorAll('[id$=disabled]').forEach(el => el.remove())
      }
      return
    }

    const fieldName = this.nameValue
    const fieldShortName = this.shortNameValue || fieldName

    // Find the closest fset-container. It is usually a sibling before the button.
    let fsetContainer = btn.previousElementSibling
    while (fsetContainer && !fsetContainer.classList.contains('fset-container')) {
      fsetContainer = fsetContainer.previousElementSibling
    }

    if (!fsetContainer) {
      console.error("Could not find .fset-container")
      return
    }

    const pathParts = window.location.pathname.split('/')
    const siteName = pathParts[2]
    const collName = pathParts[6]
    let docName = ''
    if (pathParts[4] === 'edit' || pathParts[4] === 'delete') {
      docName = pathParts.slice(7).join('/')
    }

    if (!fieldName) {
      alert('Unable to add new item. Field name is missing.')
      return
    }

    const existingFields = Array.from(fsetContainer.children).filter(el => el.matches('fieldset.list-field'))
    const nextIndex = existingFields.length

    const payload = {
      index: nextIndex,
      field_short_name: fieldShortName,
      parent_field_name: fieldName,
      doc_name: docName
    }

    const url = `/sites/render-subform/${siteName}/${collName}/${fieldName}`

    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload)
    })
    .then(response => {
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`)
      return response.json()
    })
    .then(data => {
      if (data.html) {
        fsetContainer.insertAdjacentHTML('beforeend', data.html)
        if (typeof window.Sortable !== 'undefined') {
          new window.Sortable(fsetContainer, {animation: 150, handle: '.js-sortable-handle'})
        }
      } else if (data.error) {
        alert('Failed to add new item: ' + data.error)
      } else {
        alert('Failed to add new item. Unexpected response format.')
      }
    })
    .catch(error => {
      alert('Failed to add new item: ' + error.message)
    })
  }

  remove(event) {
    const btn = event.currentTarget
    const listField = btn.closest('.list-field')
    if (listField && window._ && window._.rollupRemove) {
      window._.rollupRemove(listField)
    }
  }
}
